(function () {
  if (customElements.get('bloom-scroll-banner')) return;

  class BloomScrollBanner extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-scroll-track]');
      this.marquee = this.querySelector('[data-scroll-marquee]');

      if (!this.track || !this.marquee || this.dataset.restartOnView !== 'true') return;
      if (!('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.restartAnimation();
        });
      }, { threshold: 0.1 });

      this.observer.observe(this.marquee);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }

    restartAnimation() {
      if (!this.track) return;
      this.track.style.animation = 'none';
      void this.track.offsetHeight;
      this.track.style.animation = '';
    }
  }

  customElements.define('bloom-scroll-banner', BloomScrollBanner);
})();
